import { render, staticRenderFns } from "./ManageSectionModal.vue?vue&type=template&id=181d2219&scoped=true&"
import script from "./ManageSectionModal.vue?vue&type=script&lang=js&"
export * from "./ManageSectionModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageSectionModal.vue?vue&type=style&index=0&id=181d2219&scoped=true&lang=css&"
import style1 from "./ManageSectionModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d2219",
  null
  
)

export default component.exports